import { ODataObject } from '../../interfaces/odata-model.interface';
import { ConfigConstants } from '../../config/config-constants';

export class InputFieldPropertyModel {
    public constructor(
        public screenName: string,
        public fieldName: string,
        public fieldValue: string,
        public screenPos: number,
        public fieldPos: number,
        public scannable: boolean,
        public mandatory: boolean,
        public readonly: boolean,
        public minLength: number,
        public maxLength: number,
        public minValue: number,
        public maxValue: number,
        public pattern: string,
        public patternScan: string,
        public valueHelperID: string,
        public process?: ConfigConstants.PROCESS_INDICATOR,
        public defaultValue?: string,
    ) {}

    public static fromOData(data: ODataInputFieldPropertyModel): InputFieldPropertyModel {
        return new InputFieldPropertyModel(
            data.ScreenName,
            data.FieldName,
            data.FieldValue,
            parseInt(data.ScreenPos, 10),
            parseInt(data.FieldPos, 10),
            typeof data.Scannable === 'string' ? data.Scannable === 'X' : data.Scannable,
            typeof data.Mandatory === 'string' ? data.Mandatory === 'X' : data.Mandatory,
            typeof data.ReadOnly === 'string' ? data.ReadOnly === 'X' : data.ReadOnly,
            parseInt(data.MinLength, 10),
            parseInt(data.MaxLength, 10),
            parseInt(data.MinValue, 10),
            parseInt(data.MaxValue, 10),
            data.Pattern,
            data.PatternScan,
            data.ValueHelperID,
            data.Process ? <ConfigConstants.PROCESS_INDICATOR>data.Process : ConfigConstants.PROCESS_INDICATOR.INVIVO,
            data.DefaultValue,
        );
    }
}

export interface ODataInputFieldPropertyModel extends ODataObject {
    ScreenName: string;
    FieldName: string;
    Process: string;
    FieldValue: string;
    ScreenPos: string;
    FieldPos: string;
    Scannable: string | boolean;
    Mandatory: string | boolean;
    ReadOnly: string | boolean;
    MinLength: string;
    MaxLength: string;
    MinValue: string;
    MaxValue: string;
    Pattern: string;
    PatternScan: string;
    ValueHelperID: string;
    DefaultValue: string;
}
